export enum KorrespondenzValidationMessages {
	MISSING_REQUIRED_SELECT_VALUE = 'muss ausgewählt werden.',
	MISSING_VALUE = 'muss ausgefüllt werden.',
}
